import React from 'react'
import ScrollAnimation from 'react-animate-on-scroll';

const Footer = (props) => (
    <footer id="footer">
        <ScrollAnimation animateIn="fadeInRight" className="inner">
            <ul className="icons">
                <li><a href="https://www.facebook.com/Web2Alpes-2091201227827885/" className="icon alt fa-spin fa-facebook" title="page facebook web2alpes"><span className="label">Facebook</span></a></li>
            </ul>
			<ul className="copyright">
                <li>&copy; 2024 Web 2 Alpes</li>
            </ul>
			<ul className="copyright">
				<li>Sites Internet / Assistance / Conseil / Securité</li>
            </ul>
        </ScrollAnimation>
    </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js